import QuestionSectionPreview from "pages/ManagementPage/QuestionSectionPreview/QuestionSectionPreview";

export default QuestionSectionPreview;
